import React, { useEffect } from "react"

import { useTranslation } from "react-i18next"
import CRUD from "../core/genericCRUD/CRUD"
import { parsedUser } from "../../common/GetCurrentUser"
import acusacionOptions from "../../common/acusacionOptions"

const AdminExtraditadosComponent = (props: any) => {
  const [t] = useTranslation("global")
  const user = parsedUser()



  return (<>

    <CRUD
      id="extraditados"

      isModal={false}
      cssClass="modalRight"
      recordButtonsPosition="start"
      filterOpen={true}
      showModal={props.show}
      toggleCRUD={props.toggle}
      title={t("Extraditados") ?? ""}
      icon={"fas fa-users"}
      getRecordsPath={`Extraditado/list`}
      getRecordsMethod="post"
      addEditRecordPath={`Extraditado/addEdit?currentUserId=${user.ID}`}
      deleteRecordPath="Extraditado/delete"
      filterFields={[
        {
          name: "nombre",
          htmlType: "text",
          dbType: "string",
          title: t("Nombre") ?? "",
          containerClass: "col-md-4 col-12",
          required: false,
        },
        {
          name: "apellido1",
          htmlType: "text",
          dbType: "string",
          title: t("Apellido 1") ?? "",
          containerClass: "col-md-4 col-12",
          required: false,
        },

        {
          name: "apellido2",
          htmlType: "text",
          dbType: "string",
          title: t("Apellido 2") ?? "",
          containerClass: "col-md-4 col-12",
          required: false,
        },

        {
          name: "alias",
          htmlType: "text",
          dbType: "string",
          title: "Alias",
          containerClass: "col-12 col-md-4",
          required: false,
        },

        {
          name: "cedula",
          htmlType: "text",
          dbType: "string",
          title: "cedula",
          containerClass: "col-12 col-md-4",
          required: false,
        },
        {
          name: "passport",
          htmlType: "text",
          dbType: "string",
          title: "Passport",
          containerClass: "col-12 col-md-4",
          required: false,
        },

      ]}
      fieldsList={[
        { name: "identificador", htmlType: "informe", title: t("Ver Informe") ?? "" },
        { name: "vinculo", htmlType: "text", title: t("Vinculo") ?? "" },
        { name: "identificador", htmlType: "cedula", title: t("Cédula") ?? "" },
        { name: "nombres", htmlType: "text", title: t("Nombre") ?? "", },
        { name: "primerApellido", htmlType: "text", title: t("Primer Apellido") ?? "", },
        { name: "segundoApellido", htmlType: "text", title: t("Segundo Apellido") ?? "", },
        { name: "alias", htmlType: "text", title: t("Alias") ?? "", },
        { name: "foto", htmlType: "picture", title: t("Foto") ?? "", },
        { name: "fotoCedula", htmlType: "picture", title: t("Foto Cédula") ?? "", },

      ]}
      fields={[
        { name: "separator", dbType: "string", title: t("Datos Personales") ?? "", htmlType: "separator", containerClass: "col-12" },
        { name: "id", htmlType: "hidden", dbType: "string" },
        { name: "identificador", required: true, htmlType: "cedula", dbType: "string", title: t("Cédula") ?? "", containerClass: "col-12 col-md-6" },
        { name: "nombres", htmlType: "text", dbType: "string", title: t("Nombre") ?? "", containerClass: "col-12 col-md-6" },
        { name: "primerApellido", htmlType: "text", dbType: "string", title: t("Primer Apellido") ?? "", containerClass: "col-12 col-md-6" },
        { name: "segundoApellido", htmlType: "text", dbType: "string", title: t("Segundo Apellido") ?? "", containerClass: "col-12 col-md-6" },
        { name: "alias", htmlType: "text", dbType: "string", title: t("Alias") ?? "", containerClass: "col-12 col-md-6" },

        { name: "foto", htmlType: "picture", dbType: "string", title: t("Foto") ?? "", containerClass: "col-12 col-md-6" },
        { name: "fotoCedula", htmlType: "picture", dbType: "string", title: t("Foto Cédula") ?? "", containerClass: "col-12 col-md-6" },

        { name: "notas", htmlType: "textarea", dbType: "string", title: t("Notas") ?? "", containerClass: "col-12 " },
        { name: "separator", dbType: "string", title: t("Datos Caso") ?? "", htmlType: "separator", containerClass: "col-12" },
        { name: "fechaCaso", htmlType: "date", dbType: "string", title: t("Fecha del Caso") ?? "", containerClass: "col-12 col-md-6" },
        {
          name: "violacion", htmlType: "selectMultiple", dbType: "array", title: t("Acusación") ?? "", containerClass: "col-12 col-md-6", required: true,
          dataSourceLocal: acusacionOptions,
          dataSourceTextField: "name",
          dataSourceValueField: "id",
        },
        { name: "noDecreto", htmlType: "text", dbType: "string", title: t("Número de Decreto") ?? "", containerClass: "col-12 col-md-6" },
        { name: "paisExtradiccion", htmlType: "text", dbType: "string", title: t("País Extradicción") ?? "", containerClass: "col-12 col-md-6" },
        { name: "tribunal", htmlType: "text", dbType: "string", title: t("Tribunal") ?? "", containerClass: "col-12 col-md-6" },

        { name: "noCaso", htmlType: "text", dbType: "string", title: t("Número del Caso") ?? "", containerClass: "col-12 col-md-6" },
        // { name: "notaCaso", htmlType: "textarea", dbType: "string", title: t("Nota") ?? "", containerClass: "col-12 " },


        { name: "separator", dbType: "string", title: t("Fuentes") ?? "", htmlType: "separator", containerClass: "col-12" },
        { name: "enlace1", htmlType: "text", dbType: "string", title: t("Enlace 1") ?? "", containerClass: "col-12 col-md-6" },
        { name: "enlace2", htmlType: "text", dbType: "string", title: t("Enlace 2") ?? "", containerClass: "col-12 col-md-6" },
        { name: "enlace3", htmlType: "text", dbType: "string", title: t("Enlace 3") ?? "", containerClass: "col-12 col-md-6" },
        { name: "enlace4", htmlType: "text", dbType: "string", title: t("Enlace 4") ?? "", containerClass: "col-12 col-md-6" },
        { name: "enlace5", htmlType: "text", dbType: "string", title: t("Enlace 5") ?? "", containerClass: "col-12 col-md-6" },


      ]}
    />
  </>
  )
}

export default AdminExtraditadosComponent
